import type { CookieService } from "@/src/infrastructure/cookieconsent/CookieService";

import { themeColor } from "@/src/app/metadata";
import { CookieCategory } from "@/src/infrastructure/cookieconsent/CookieCategory";

const themeColorHex = themeColor.slice(1);

export const googleMapsEmbedOrigin = "https://www.google.com";

export const googleMapsCookie: CookieService<CookieCategory.FEATURES> = {
  category: CookieCategory.FEATURES,
  iframe: {
    embedUrl: `${googleMapsEmbedOrigin}/maps/d/embed?mid={data-id}&ehbc=${themeColorHex}`,
    label: "Pour voir la carte",
  },
  name: "Google Maps",
  privacyPolicyUrl: "https://policies.google.com/privacy",
  purpose: "Cartes interactives",
};
